<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "SubscriptionList" });
import * as API from "../../services/api.js";
import { SUBSCRIPTION_STORE, SUBSCRIPTION_HASH } from "../../services/store.js";
import { onDestroy, onMount } from "svelte";
import { get, writable, derived } from "svelte/store";
export let parameters;
const STORE = writable([]);
let unsubscribe;
let isLoading = false;
let previousParams = "";
let previousHash = $SUBSCRIPTION_HASH;
const syncFromGlobalStore = (data) => {
    const SUBSCRIPTIONS = get(STORE).map((subscription) => {
        const KEY = subscription._.key;
        if (!(KEY in data)) {
            return subscription;
        }
        return data[KEY];
    });
    STORE.set(SUBSCRIPTIONS);
};
const setStore = (subscriptions) => {
    STORE.set(subscriptions);
    isLoading = false;
};
const onParametersChange = (parameters2) => {
    const CURRENT_PARAMS = JSON.stringify(parameters2);
    if (CURRENT_PARAMS === previousParams) {
        return;
    }
    previousParams = CURRENT_PARAMS;
    isLoading = true;
    void API.filterSubscriptions({ ...parameters2 }).then(setStore);
};
$: onParametersChange(parameters);
const onSubscriptionHashChange = (hash) => {
    if (hash === previousHash) {
        return;
    }
    previousHash = $SUBSCRIPTION_HASH;
    isLoading = true;
    void API.filterSubscriptions({ ...parameters }).then(setStore);
};
$: onSubscriptionHashChange($SUBSCRIPTION_HASH);
onMount(() => {
    unsubscribe = SUBSCRIPTION_STORE.subscribe(syncFromGlobalStore);
});
onDestroy(() => {
    if (unsubscribe !== void 0) {
        unsubscribe();
    }
});
export const COUNT = derived(STORE, ($STORE) => $STORE.length);
</script>

{#if isLoading}
    <slot name = 'loading'/>
{:else if Array.isArray($STORE) && $STORE.length > 0}
    <slot subscriptions = { $STORE }>
        <pre>{ JSON.stringify($STORE, null, 4) }</pre>
    </slot>
{:else}
    <slot name = 'empty' />
{/if}